import { LocaleSwitcher as UiLocaleSwitcher, LOCALE_SHORT_NAMES } from '@kilat/ui';

import { useI18n, LOCALE_NATIVE_NAMES } from '../lib/use-i18n.js';
import type { Locale } from '@kilat/shared';

/**
 * Sprint 88 — thin agent-pwa wrapper for the shared `<LocaleSwitcher>`.
 * Mirrors customer-pwa + marketing wrappers — the nudge copy is
 * tailored to the agent voice (work-focused).
 */
const NUDGE_LINES: Record<Locale, string> = {
  en: 'Set to English from your device. Tap to switch.',
  ms: 'Ditetapkan kepada Bahasa Malaysia dari peranti anda. Tekan untuk tukar.',
  zh: '已根据您的设备设为中文,点击切换。',
  ta: 'உங்கள் சாதனத்திலிருந்து தமிழ் தேர்ந்தெடுக்கப்பட்டது. மாற்ற தட்டவும்.',
};

export function LocaleSwitcher() {
  const { locale, setLocale, supportedLocales, firstLaunchDetected } = useI18n();
  return (
    <UiLocaleSwitcher<Locale>
      locale={locale}
      setLocale={setLocale}
      supportedLocales={supportedLocales}
      nativeNames={LOCALE_NATIVE_NAMES}
      shortNames={LOCALE_SHORT_NAMES}
      firstLaunchDetected={firstLaunchDetected}
      nudgeLines={NUDGE_LINES}
    />
  );
}
